import { useState, useEffect, useCallback, useContext } from 'react';
import { createContext } from 'react';

const STORAGE_KEY = 'neonpharma_saved_promos';

export const useSavedPromos = () => {
  const [savedIds, setSavedIds] = useState<number[]>([]);
  const [isReady, setIsReady] = useState(false);

  useEffect(() => {
    try {
      const stored = localStorage.getItem(STORAGE_KEY);
      if (stored) {
        const parsed = JSON.parse(stored);
        if (Array.isArray(parsed)) setSavedIds(parsed);
      }
    } catch {
      // ignore
    }
    setIsReady(true);
  }, []);

  useEffect(() => {
    if (isReady) {
      try {
        localStorage.setItem(STORAGE_KEY, JSON.stringify(savedIds));
      } catch {
        // ignore
      }
    }
  }, [savedIds, isReady]);

  const isSaved = useCallback((id: number) => savedIds.includes(id), [savedIds]);

  const toggleSave = useCallback((id: number) => {
    setSavedIds((prev) =>
      prev.includes(id) ? prev.filter((i) => i !== id) : [...prev, id]
    );
    return !savedIds.includes(id); // returns true if now saved
  }, [savedIds]);

  const save = useCallback((id: number) => {
    setSavedIds((prev) => (prev.includes(id) ? prev : [...prev, id]));
  }, []);

  const remove = useCallback((id: number) => {
    setSavedIds((prev) => prev.filter((i) => i !== id));
  }, []);

  return {
    savedIds,
    isSaved,
    toggleSave,
    save,
    remove,
    count: savedIds.length,
    isReady,
  };
};